import React from 'react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';

class ExportOrders extends React.Component {
  constructor(props) {
    super(props);

    const today = new Date();

    this.state = {
      start: new Date(today.getFullYear(), today.getMonth() - 1, 1),
      end: new Date(today.getFullYear(), today.getMonth(), 0),
    };

    this.handleDayChange = this.handleDayChange.bind(this);
    this.export = this.export.bind(this);
  }

  handleDayChange(name) {
    const self = this;
    return function(value) {
      self.setState({ [name]: new Date(value.setHours(0,0,0,0)) });
    }
  }

  export() {
    const { start, end } = this.state;
    const { path } = this.props;
    let schemeAuth = '';

    if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
        var scheme = 'http';
        var authority = 'localhost';
        var port = '8081';
        schemeAuth = scheme+'://'+authority+':'+port;
    }

    window.location = `${schemeAuth}/api/v1/export/${path}?start=${start.toISOString()}&end=${end.toISOString()}`;
  }

  render() {
    const { start, end } = this.state;

    return (
      <div className="filters-container">
        <div className="input-container field-wrap">
          <label className="active">export start date</label>
          <DayPickerInput
            onDayChange={this.handleDayChange('start')}
            value={start}
          /> 
        </div>
        <div className="input-container field-wrap">
          <label className="active">export end date</label>
          <DayPickerInput
            onDayChange={this.handleDayChange('end')}
            value={end}
          /> 
        </div>
        <button onClick={this.export}>Export</button>
        <div className="clearfix"/>      
      </div>
    );
  }
}

export default ExportOrders;



// WEBPACK FOOTER //
// ./source/components/ExportOrders.js